<template>
  <div class="Trio-btn-row">
    <p v-if="errorText" class="Trio-error-form">* {{ errorText }}</p>
    <button @click="sendClickEvent" class="Trio-btn" :disabled="isDisabled">
      <slot></slot>
    </button>
  </div>
</template>

<script>
export default {
  name: "TrioLink",
  props: ["errorText", "isDisabled"],
  methods: {
    sendClickEvent() {
      this.$emit("clicked");
    },
  },
};
</script>
